import { clsx } from 'clsx'
import React from 'react'
import { Pressable, View, type PressableProps, type ViewProps } from 'react-native'

import { useCardContext } from './card-context'

type TCardHeaderProps = ViewProps & Pick<PressableProps, 'onPress'> & { ref?: React.Ref<View> }

export const CardHeader = ({ ref, className, children, ...otherProps }: TCardHeaderProps) => {
  const { slots, classNames } = useCardContext()

  const Component = otherProps.onPress ? Pressable : View

  const headerStyles = clsx(classNames?.header, className)

  return (
    <Component className={slots.header?.({ class: headerStyles })} ref={ref} {...otherProps}>
      {children}
    </Component>
  )
}

CardHeader.displayName = 'CardHeader'
